module.exports = __webpack_public_path__ + "static/media/mode-65.62866528.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-65.svg
// module id = 1036
// module chunks = 2